// InterruttoriScelte.tsx — v040: le spunte di «Le tue scelte», uguali nel profilo, nella finestra «Le tue scelte»
// della partita e nella domanda dopo la prima partita (v045, «Scelgo io»). v045: foto, video delle risate e «Video per
// noi» (con il link al testo della liberatoria); «Video online» non c'è più.
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { clipPossibili } from "../gioco/usaClip.ts";
import { salvaScelte, useScelte, vociPossibili, type Scelte, type VoceScelta } from "../servizi/scelte.ts";
import { useAccount } from "../servizi/account.ts";
import { BASE_API, PERCORSO_PRIVACY } from "../costanti.ts";

export const ICONE_SCELTE: Record<VoceScelta, string> = { foto: "📸", video: "🎬", noi: "💛" };

/** Quali voci hanno senso su questo telefono (video spenti dal pannello o telefono che non li sa fare: niente voce). */
export function vociScelte(): VoceScelta[] {
  return vociPossibili(clipPossibili());
}

/** Il link al testo completo del «Video per noi» (la sezione dell'informativa privacy), in una scheda nuova. */
export function LinkLiberatoria() {
  const { t, i18n } = useTranslation();
  return (
    <a className="ld-scelta-link" href={`${BASE_API}${PERCORSO_PRIVACY}?lingua=${encodeURIComponent(i18n.language)}#video-per-noi`} target="_blank" rel="noopener" onClick={(e) => e.stopPropagation()}>
      {t("scelte.noi_link")}
    </a>
  );
}

/** Le spunte, controllate da fuori (chi le usa salva con il suo pulsante). `solo` = mostra solo queste voci. */
export function SpunteScelte({ valori, onCambia, solo }: { valori: Scelte; onCambia: (s: Scelte) => void; solo?: readonly VoceScelta[] }) {
  const { t } = useTranslation();
  const voci = vociScelte().filter((k) => !solo || solo.includes(k));
  // «Video per noi» compare solo con il video acceso (niente spunte che non si possono toccare)
  const riga = (k: VoceScelta) =>
    (k !== "noi" || valori.video) && (
      <label className="ld-volto-spunta ld-scelta" key={k} data-voce={k}>
        <input type="checkbox" checked={valori[k]} onChange={(e) => onCambia({ ...valori, [k]: e.target.checked, ...(k === "video" && !e.target.checked ? { noi: false } : {}) })} />
        <span className="ld-scelta-testo">
          <span>
            <span aria-hidden="true">{ICONE_SCELTE[k]} </span>
            {t(`scelte.${k}`)}
          </span>
          <span className="ld-scelta-nota">
            {t(`scelte.${k}_nota`)}
            {k === "noi" && (
              <>
                {" "}
                <LinkLiberatoria />
              </>
            )}
          </span>
        </span>
      </label>
    );
  return <div className="ld-scelte">{voci.map(riga)}</div>;
}

/** Le spunte che salvano subito (profilo, partita). */
export function InterruttoriScelte() {
  const { t } = useTranslation();
  useAccount(); // le scelte dell'account arrivano con il profilo
  const scelte = useScelte();
  const [errore, setErrore] = useState(false);
  const [salvato, setSalvato] = useState<"si" | "ritirato" | null>(null);
  return (
    <>
      <SpunteScelte
        valori={scelte}
        onCambia={(s) => {
          setErrore(false);
          setSalvato(null);
          const ritiro = scelte.noi && !s.noi;
          salvaScelte(s)
            .then(() => setSalvato(ritiro ? "ritirato" : "si"))
            .catch(() => setErrore(true));
        }}
      />
      {salvato && (
        <p className="nota" role="status">
          {salvato === "ritirato" ? t("scelte.noi_ritirato") : t("account.salvato")}
        </p>
      )}
      {errore && (
        <p className="nota" role="alert">
          {t("scelte.errore")}
        </p>
      )}
    </>
  );
}
